import { PageType as DefaultPageType } from '../Page.js';

export import PageType = DefaultPageType;